import React,{useEffect, useState} from 'react';
import './RadioButtons.css';
import { FormControl, Radio, RadioGroup, FormControlLabel } from '@mui/material';

const RadioButtons = (props) => {
    const [value, setValue] = useState('new');

    const handleChange = (event) => {   
        const newRequestType = event.target.value;     
        //setValue(event.target.value);
        if( (value === 'new' && newRequestType === 'change request') ||
        (value === 'change request' && newRequestType === 'new') || (value === 'new' && newRequestType === 'others') ||
        (value === 'others' && newRequestType === 'new') ||  (value === 'change request' && newRequestType === 'others') || 
        (value === 'others' && newRequestType === 'change request')) {
            props.setCategory('select')
            props.setName('')
            props.setStakeholderName('')
            props.setDescription('')
            props.setSummary('')
            props.setSelectedMembers([]);
            props.setSelectedProject('');
            props.setRequestedStartDate(null);
            props.setRequestedEndDate(null);
        }
        setValue(newRequestType);
        };

    useEffect(() => {
        props.setRequestType(value);
    },[value])
    
    return (
        <FormControl component="fieldset">
            <RadioGroup aria-label="selection" name="selection" value={value} onChange={handleChange}>
                <FormControlLabel value="new" control={<Radio />} label="New" />
                <FormControlLabel value="change request" control={<Radio />} label="Change Req." />
                <FormControlLabel value="others" control={<Radio />} label="Others" />
            </RadioGroup>
        </FormControl>
    )
}

export default RadioButtons;